import { EmblaOptionsType } from "embla-carousel";

export const footerSliderConfig: EmblaOptionsType = {
    skipSnaps: true,
    align: "start",
};
